module.exports = __webpack_public_path__ + "img/6.ceb25da4.png";